import CaProfileMapper from "../mappers/CaProfileMapper";
import CaProfile from "../models/domain/CaProfile";
import CaProfileRaw from "../models/domain/CaProfileRaw";
import { getAuthProfileRaw } from "./authStorage";
import { getRouterBasename } from "../portals/portalConfig";

const emptyCaProfile = new CaProfile("", "", "", "", []);

export function retrieveCaProfile(): CaProfile {
  const profileRaw = getAuthProfileRaw();
  if (!profileRaw) {
    const base = getRouterBasename();
    document.location.href = base === "/" ? "/" : `${base}/`;
    return emptyCaProfile;
  }

  const parsed = JSON.parse(profileRaw) as CaProfileRaw;
  return CaProfileMapper.mapRawToModel(parsed);
}
